'use strict';

module.exports = {
  MASK_MODE: parseInt('7777', 8),
  DEFAULT_FILE_MODE: parseInt('0666', 8),
  DEFAULT_ENCODING: 'utf8',
};
